import React from "react";
import { motion } from "framer-motion";
import "./Hero.css";

const Hero = () => {
    const fadeInUp = {
        initial: { opacity: 0, y: 60 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.8, ease: "easeOut" },
    };

    const staggerChildren = {
        animate: {
            transition: {
                staggerChildren: 0.2,
            },
        },
    };

    const scrollToContact = (e) => {
        e.preventDefault();
        const contactSection = document.getElementById("contact");
        if (contactSection) {
            const header = document.querySelector(".header");
            const headerHeight = header.offsetHeight - 120; // match Header Join Now offset
            const elementPosition = contactSection.offsetTop;
            const offsetPosition = elementPosition - headerHeight;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        }
    };

    const scrollToFeatures = (e) => {
        e.preventDefault();
        const featuresSection = document.getElementById("features");
        if (featuresSection) {
            const header = document.querySelector(".header");
            const headerHeight = header.offsetHeight - 120; // match Benefits offset
            const elementPosition = featuresSection.offsetTop;
            const offsetPosition = elementPosition - headerHeight;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        }
    };

    return (
        <section className="hero">
            <div className="container">
                <motion.div
                    className="hero-content"
                    variants={staggerChildren}
                    initial="initial"
                    animate="animate">
                    <motion.h1 variants={fadeInUp}>Join Stamp Medical</motion.h1>

                    <motion.p variants={fadeInUp}>We're your new partner in the world of Personal Injury. Additional revenue is just around the corner for your practice, and we will help you get it. All you do is the treatment - we'll take care of the rest.</motion.p>

                    <motion.div
                        className="hero-buttons"
                        variants={fadeInUp}>
                        <button
                            className="btn btn-primary"
                            onClick={scrollToContact}>
                            Join Now
                        </button>
                        <button
                            className="btn btn-secondary"
                            onClick={scrollToFeatures}>
                            Learn More
                        </button>
                    </motion.div>
                </motion.div>
            </div>

            <div className="hero-visual">
                <motion.div
                    className="hero-image"
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 1.2, delay: 0.5 }}>
                    <div className="medical-placeholder">
                        <div className="medical-silhouette"></div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default Hero;
